module.exports = __webpack_public_path__ + "img/total.13be9de6.svg";